import { render } from "./CreateService.vue?vue&type=template&id=fa92d444&scoped=true"
import script from "./CreateService.vue?vue&type=script&lang=js"
export * from "./CreateService.vue?vue&type=script&lang=js"

import "./CreateService.vue?vue&type=style&index=0&id=fa92d444&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa92d444"]])

export default __exports__